import React, { useMemo } from 'react';
import _ from 'underscore';
import { TaxUtils, Constants } from '@bingads-webui-clientcenter/entity-utils';
import { StringUtils } from '@bingads-webui-clientcenter/common-utils';
import { TaxTypeFormPropTypes } from '../shapes';
import { GlobalTaxForm } from './global-taxform';
import { CustomValidateItems } from '../validator';
import { EmptyTaxForm } from './empty-taxform';
import { registerTaxform } from '../taxform-store';
import { SNTaxViewTaxForm } from './viewtaxforms/senegal-viewtaxform';
import { EmptyViewTaxForm } from './viewtaxforms/empty-viewtaxform';
import { withViewTaxFormWithFilledEmptyTaxValue, withTaxFormByPilot } from '../utils';
import { GlobalTaxIdHelpPopUpId, GlobalTaxIdCountryCodeToPilots } from '../constants';

const { getTaxTypeLabel } = TaxUtils;
const {
  TaxSNVatNumberRegExp, TaxType, TaxLabelFormat, CountryCode,
} = Constants;
const { regexTest } = StringUtils;

const taxIdValidator = _.partial(regexTest, TaxSNVatNumberRegExp);
const taxSchemaGetter = () => ({
  name: 'Senegal Taxation Validation Schema',
  type: 'object',
  properties: {
    [TaxType.VatNumber]: {
      type: 'string',
      required: false,
      helpPopupTopic: GlobalTaxIdHelpPopUpId,
    },
  },
});

export const SNTaxForm = ({
  i18n,
  onValidate,
  showLineByLineFormGroup,
  alwaysShowError,
  data,
  mtData,
  taxCertification,
  mtTaxCertification,
  disabled,
}) => {
  const vatValidatorErrorMessage = useMemo(() => i18n.getString(CustomValidateItems.SenegalVATFormatValidation), [i18n]);
  const vatLabel = useMemo(() => getTaxTypeLabel(TaxType.VatNumber, i18n, { labelFormat: TaxLabelFormat.RequiredForBusiness, countryCode: CountryCode.SN }), [i18n]);

  return (
    <GlobalTaxForm
      i18n={i18n}
      onValidate={onValidate}
      taxSchemaGetter={taxSchemaGetter}
      vatLabel={vatLabel}
      showLineByLineFormGroup={showLineByLineFormGroup}
      vatValidatorErrorMessage={vatValidatorErrorMessage}
      alwaysShowError={alwaysShowError}
      data={data}
      mtData={mtData}
      taxCertification={taxCertification}
      mtTaxCertification={mtTaxCertification}
      disabled={disabled}
      taxIdValidator={taxIdValidator}
      showTaxCert={false}
    />
  );
};

SNTaxForm.propTypes = TaxTypeFormPropTypes;

const globalPilotFlag = GlobalTaxIdCountryCodeToPilots.SN;

const TaxForm = withTaxFormByPilot({
  pilotFlag: globalPilotFlag,
  PilotForm: SNTaxForm,
  DefaultForm: EmptyTaxForm,
});

const ViewTaxForm = withTaxFormByPilot({
  pilotFlag: globalPilotFlag,
  PilotForm: SNTaxViewTaxForm,
  DefaultForm: EmptyViewTaxForm,
});

registerTaxform('/SN/', TaxForm, withViewTaxFormWithFilledEmptyTaxValue({ ViewTaxForm, getTaxSchema: taxSchemaGetter }));
